import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGooglePlayFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_14119_11053)",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.5075 1.51166L11.9933 9.99999L3.50833 18.4883C3.35745 18.4249 3.22869 18.3183 3.13824 18.1819C3.0478 18.0454 2.9997 17.8853 3 17.7217V2.27832C3.00007 2.11484 3.04821 1.95499 3.13845 1.81867C3.22869 1.68235 3.35703 1.57558 3.5075 1.51166ZM12.5825 10.5892L14.5008 12.5075L5.38667 17.785L12.5825 10.5892ZM15.2483 7.92416L17.5875 9.27916C17.7138 9.35241 17.8186 9.45756 17.8915 9.58406C17.9643 9.71057 18.0027 9.854 18.0027 9.99999C18.0027 10.146 17.9643 10.2894 17.8915 10.4159C17.8186 10.5424 17.7138 10.6476 17.5875 10.7208L15.2475 12.0758L13.1717 9.99999L15.2483 7.92416ZM5.38667 2.21499L14.5017 7.49166L12.5825 9.41082L5.38667 2.21499Z" })
	})
});
export default SvgGooglePlayFill;
